function init_courses_widget(elm, filters) {
    const $ = jQuery.noConflict();

    let wait = 500;
    elm.find('table').each(function() {
        const table = $(this);

        setTimeout(() => {
            table.reloadThisElement(() => {
                let count = parseInt(table.attr('data-total-count'));
                count = isNaN(count) ? 0 : count;

                const index = table.parents('.tab-content').index();
                const tabButton = table.parents('.tabs-wrapper').find('.tabs-header .tab:eq(' + (index) + ')');

                let str = tabButton.attr('data-original');
                if (!str) {
                    str = tabButton.html();
                    tabButton.attr('data-original', str);
                }

                str = str + ' <sup>(' + count + ')</sup>';
                tabButton.html(str);
            });
        }, wait);
        wait = wait + 500;
    });

}